/**
 * Quick Menu Component
 */
export class QuickMenu {
    constructor() {
        this.topBtn = document.getElementById('quick-menu-top');
        this.menu = document.getElementById('quick-menu');
        this.servicePop = document.getElementById('servicePop');
        this.serviceTrigger = document.getElementById('quick-menu-service');

        if (this.topBtn || this.serviceTrigger) {
            this.init();
        }
    }

    init() {
        this.initDynamicWidths();
        this.initServicePopup();

        if (this.topBtn) {
            this.topBtn.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }
    }

    initServicePopup() {
        if (!this.servicePop || !this.serviceTrigger) return;

        const open = () => {
            this.servicePop.removeAttribute('hidden');
            this.servicePop.setAttribute('data-open', 'true');
            document.body.classList.add('hl-service-popup-open');
        };

        const close = () => {
            this.servicePop.setAttribute('data-open', 'false');
            this.servicePop.setAttribute('hidden', '');
            document.body.classList.remove('hl-service-popup-open');
        };

        this.serviceTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            open();
        });

        this.servicePop.querySelectorAll('[data-service-popup-close]').forEach((el) => {
            el.addEventListener('click', close);
        });

        this.servicePop.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') close();
        });
    }

    initDynamicWidths() {
        if (!this.menu) return;

        const items = Array.from(
            this.menu.querySelectorAll('.hl-quick-menu__item')
        );
        if (items.length === 0) return;

        const measure = () => {
            items.forEach((item) => {
                // Top button doesn't expand (by design)
                if (item.classList.contains('hl-quick-menu__item--top')) return;

                const icon = item.querySelector('.hl-quick-menu__icon');
                const text = item.querySelector('.hl-quick-menu__text');
                if (!icon || !text) return;

                // Ensure we can measure even when text is visually hidden
                const prevOpacity = text.style.opacity;
                const prevWidth = text.style.width;
                const prevMaxWidth = text.style.maxWidth;
                const prevOverflow = text.style.overflow;
                const prevPosition = text.style.position;
                const prevVisibility = text.style.visibility;
                const prevTransform = text.style.transform;
                const prevPointerEvents = text.style.pointerEvents;

                text.style.opacity = '1';
                text.style.width = 'auto';
                text.style.maxWidth = 'none';
                text.style.overflow = 'visible';
                text.style.position = 'absolute';
                text.style.visibility = 'hidden';
                text.style.transform = 'none';
                text.style.pointerEvents = 'none';

                const textWidth = Math.ceil(text.getBoundingClientRect().width);

                // Restore inline styles
                text.style.opacity = prevOpacity;
                text.style.width = prevWidth;
                text.style.maxWidth = prevMaxWidth;
                text.style.overflow = prevOverflow;
                text.style.position = prevPosition;
                text.style.visibility = prevVisibility;
                text.style.transform = prevTransform;
                text.style.pointerEvents = prevPointerEvents;

                const iconWidth = Math.ceil(icon.getBoundingClientRect().width);

                // Mirrors SCSS hover padding/border-radius behavior
                const paddingLeft = 18; // 1.8rem
                const iconGap = 8; // 0.8rem
                const rightPadding = 0; // align to right edge (icon container)
                const minExpanded = 180; // fallback lower bound (18rem)
                const maxExpanded = 260; // fallback upper bound (26rem)

                const expanded =
                    paddingLeft + textWidth + iconGap + iconWidth + rightPadding;
                const clamped = Math.max(minExpanded, Math.min(maxExpanded, expanded));

                item.style.setProperty(
                    '--hl-quick-menu-expanded-width',
                    `${clamped}px`
                );
            });
        };

        measure();

        let resizeTimer = null;
        window.addEventListener('resize', () => {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(measure, 150);
        });
    }
}

